import './heart.css';
import React from 'react';
import { Link } from 'react-router-dom';
import cartoonwitch from '../assets/cartoonwitch.png'
import caterpillarpumpkin from '../assets/caterpillarpumpkin.png'
import twoheadsheep from '../assets/twoheadsheep.png'

function Quizzes() {

  return (
    <div className="heart-page">

        {/* Floating text blocks */}
        
        <Link to="/witchquiz" className="witch-button">
          <img src={cartoonwitch} alt="what kind of Witch are you?" className="witch-image" />
        </Link>

        <Link to="/karmaquiz" className="karma-button">
          <img src={caterpillarpumpkin} alt="is karma coming for you?" className="karma-image" />
        </Link>

        <Link to="/friendsgiving" className="giving-button">
          <img src={twoheadsheep} alt="friendsgiving?" className="friendsgiving-image" />
        </Link>

    </div>
  );
}
 export default Quizzes;